import DeviceView from "Components/Device/DeviceView";
import FlowDiagramHolder from "Components/Device/Flow/FlowDiagramHolder";
import FlowMenu from "Components/Device/Flow/FlowMenu";
import React, { Fragment } from "react";

const FlowView = () => {
  return (
    <Fragment>
      <FlowMenu />
      <FlowDiagramHolder />
      <DeviceView />
    </Fragment>
  );
};

export default FlowView;
